var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeatmapsPrediction6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Heatmaps_Prediction_6",
    "data-name": "Heatmaps Prediction 6",
    transform: "translate(713 18906)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Heatmap_BG",
    "data-name": "Heatmap BG",
    transform: "translate(-713 -18906)",
    fill: "#d3d3d3",
    stroke: "#fff",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 400,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 395,
    height: 395,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Heatmap_Square",
    "data-name": "Heatmap Square",
    transform: "translate(-367.833 -18561)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Heat_Map_BG",
    "data-name": "Heat Map BG",
    width: 49.75,
    height: 49.75,
    fill: "#002927"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Heatmap_Square-2",
    "data-name": "Heatmap Square",
    transform: "translate(-415.833 -18561)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Heat_Map_BG-2",
    "data-name": "Heat Map BG",
    width: 49.75,
    height: 49.75,
    fill: "#008e7a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Heatmap_Square-3",
    "data-name": "Heatmap Square",
    transform: "translate(-465.024 -18561)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Heat_Map_BG-3",
    "data-name": "Heat Map BG",
    width: 49.75,
    height: 49.75,
    fill: "#008e7a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Heatmap_Square-4",
    "data-name": "Heatmap Square",
    transform: "translate(-513.619 -18561)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Heat_Map_BG-4",
    "data-name": "Heat Map BG",
    width: 49.75,
    height: 49.75,
    fill: "#aaafb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Heatmap_Square-5",
    "data-name": "Heatmap Square",
    transform: "translate(-561.06 -18561)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Heat_Map_BG-5",
    "data-name": "Heat Map BG",
    width: 49.75,
    height: 49.75,
    fill: "#d6d6d6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Heatmap_Square-6",
    "data-name": "Heatmap Square",
    transform: "translate(-609.81 -18561)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Heat_Map_BG-6",
    "data-name": "Heat Map BG",
    width: 49.75,
    height: 49.75,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Heatmap_Square-7",
    "data-name": "Heatmap Square",
    transform: "translate(-659 -18561)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Heat_Map_BG-7",
    "data-name": "Heat Map BG",
    width: 49.75,
    height: 49.75,
    fill: "#d6d6d6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Heatmap_Square-8",
    "data-name": "Heatmap Square",
    transform: "translate(-708 -18561)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Heat_Map_BG-8",
    "data-name": "Heat Map BG",
    width: 49.75,
    height: 49.75,
    fill: "#d6d6d6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Heatmap_Square-9",
    "data-name": "Heatmap Square",
    transform: "translate(-368.708 -18607)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Heat_Map_BG-9",
    "data-name": "Heat Map BG",
    width: 49.75,
    height: 49.75,
    fill: "#002927"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Heatmap_Square-10",
    "data-name": "Heatmap Square",
    transform: "translate(-415.833 -18607)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Heat_Map_BG-10",
    "data-name": "Heat Map BG",
    width: 49.75,
    height: 49.75,
    fill: "#aaafb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Heatmap_Square-11",
    "data-name": "Heatmap Square",
    transform: "translate(-465.024 -18607)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Heat_Map_BG-11",
    "data-name": "Heat Map BG",
    width: 49.75,
    height: 49.75,
    fill: "#aaafb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Heatmap_Square-12",
    "data-name": "Heatmap Square",
    transform: "translate(-513.619 -18607)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Heat_Map_BG-12",
    "data-name": "Heat Map BG",
    width: 49.75,
    height: 49.75,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Heatmap_Square-13",
    "data-name": "Heatmap Square",
    transform: "translate(-561.06 -18607)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Heat_Map_BG-13",
    "data-name": "Heat Map BG",
    width: 49.75,
    height: 49.75,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Heatmap_Square-14",
    "data-name": "Heatmap Square",
    transform: "translate(-609.81 -18607)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Heat_Map_BG-14",
    "data-name": "Heat Map BG",
    width: 49.75,
    height: 49.75,
    fill: "#d6d6d6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Heatmap_Square-15",
    "data-name": "Heatmap Square",
    transform: "translate(-659 -18607)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Heat_Map_BG-15",
    "data-name": "Heat Map BG",
    width: 49.75,
    height: 49.75,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Heatmap_Square-16",
    "data-name": "Heatmap Square",
    transform: "translate(-708 -18607)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Heat_Map_BG-16",
    "data-name": "Heat Map BG",
    width: 49.75,
    height: 49.75,
    fill: "#d6d6d6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Heatmap_Square-17",
    "data-name": "Heatmap Square",
    transform: "translate(-367.833 -18656)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Heat_Map_BG-17",
    "data-name": "Heat Map BG",
    width: 49.75,
    height: 49.75,
    fill: "#96c5b6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Heatmap_Square-18",
    "data-name": "Heatmap Square",
    transform: "translate(-415.833 -18656)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Heat_Map_BG-18",
    "data-name": "Heat Map BG",
    width: 49.75,
    height: 49.75,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Heatmap_Square-19",
    "data-name": "Heatmap Square",
    transform: "translate(-465.024 -18656)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Heat_Map_BG-19",
    "data-name": "Heat Map BG",
    width: 49.75,
    height: 49.75,
    fill: "#d6d6d6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Heatmap_Square-20",
    "data-name": "Heatmap Square",
    transform: "translate(-513.619 -18656)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Heat_Map_BG-20",
    "data-name": "Heat Map BG",
    width: 49.75,
    height: 49.75,
    fill: "#d6d6d6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Heatmap_Square-21",
    "data-name": "Heatmap Square",
    transform: "translate(-561.06 -18656)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Heat_Map_BG-21",
    "data-name": "Heat Map BG",
    width: 49.75,
    height: 49.75,
    fill: "#d6d6d6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Heatmap_Square-22",
    "data-name": "Heatmap Square",
    transform: "translate(-609.81 -18656)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Heat_Map_BG-22",
    "data-name": "Heat Map BG",
    width: 49.75,
    height: 49.75,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Heatmap_Square-23",
    "data-name": "Heatmap Square",
    transform: "translate(-659 -18656)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Heat_Map_BG-23",
    "data-name": "Heat Map BG",
    width: 49.75,
    height: 49.75,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Heatmap_Square-24",
    "data-name": "Heatmap Square",
    transform: "translate(-708 -18656)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Heat_Map_BG-24",
    "data-name": "Heat Map BG",
    width: 49.75,
    height: 49.75,
    fill: "#d6d6d6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Heatmap_Square-25",
    "data-name": "Heatmap Square",
    transform: "translate(-367.833 -18705)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Heat_Map_BG-25",
    "data-name": "Heat Map BG",
    width: 49.75,
    height: 49.75,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Heatmap_Square-26",
    "data-name": "Heatmap Square",
    transform: "translate(-415.833 -18705)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Heat_Map_BG-26",
    "data-name": "Heat Map BG",
    width: 49.75,
    height: 49.75,
    fill: "#aaafb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Heatmap_Square-27",
    "data-name": "Heatmap Square",
    transform: "translate(-465.024 -18705)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Heat_Map_BG-27",
    "data-name": "Heat Map BG",
    width: 49.75,
    height: 49.75,
    fill: "#aaafb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Heatmap_Square-28",
    "data-name": "Heatmap Square",
    transform: "translate(-513.619 -18705)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Heat_Map_BG-28",
    "data-name": "Heat Map BG",
    width: 49.75,
    height: 49.75,
    fill: "#d6d6d6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Heatmap_Square-29",
    "data-name": "Heatmap Square",
    transform: "translate(-561.06 -18705)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Heat_Map_BG-29",
    "data-name": "Heat Map BG",
    width: 49.75,
    height: 49.75,
    fill: "#d6d6d6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Heatmap_Square-30",
    "data-name": "Heatmap Square",
    transform: "translate(-609.81 -18705)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Heat_Map_BG-30",
    "data-name": "Heat Map BG",
    width: 49.75,
    height: 49.75,
    fill: "#96c5b6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Heatmap_Square-31",
    "data-name": "Heatmap Square",
    transform: "translate(-659 -18705)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Heat_Map_BG-31",
    "data-name": "Heat Map BG",
    width: 49.75,
    height: 49.75,
    fill: "#96c5b6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Heatmap_Square-32",
    "data-name": "Heatmap Square",
    transform: "translate(-708 -18705)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Heat_Map_BG-32",
    "data-name": "Heat Map BG",
    width: 49.75,
    height: 49.75,
    fill: "#aaafb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Heatmap_Square-33",
    "data-name": "Heatmap Square",
    transform: "translate(-367.833 -18754)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Heat_Map_BG-33",
    "data-name": "Heat Map BG",
    width: 49.75,
    height: 49.75,
    fill: "#d6d6d6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Heatmap_Square-34",
    "data-name": "Heatmap Square",
    transform: "translate(-415.833 -18754)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Heat_Map_BG-34",
    "data-name": "Heat Map BG",
    width: 49.75,
    height: 49.75,
    fill: "#d6d6d6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Heatmap_Square-35",
    "data-name": "Heatmap Square",
    transform: "translate(-465.024 -18754)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Heat_Map_BG-35",
    "data-name": "Heat Map BG",
    width: 49.75,
    height: 49.75,
    fill: "#d6d6d6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Heatmap_Square-36",
    "data-name": "Heatmap Square",
    transform: "translate(-513.619 -18754)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Heat_Map_BG-36",
    "data-name": "Heat Map BG",
    width: 49.75,
    height: 49.75,
    fill: "#d6d6d6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Heatmap_Square-37",
    "data-name": "Heatmap Square",
    transform: "translate(-561.06 -18754)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Heat_Map_BG-37",
    "data-name": "Heat Map BG",
    width: 49.75,
    height: 49.75,
    fill: "#d6d6d6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Heatmap_Square-38",
    "data-name": "Heatmap Square",
    transform: "translate(-609.81 -18754)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Heat_Map_BG-38",
    "data-name": "Heat Map BG",
    width: 49.75,
    height: 49.75,
    fill: "#aaafb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Heatmap_Square-39",
    "data-name": "Heatmap Square",
    transform: "translate(-659 -18754)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Heat_Map_BG-39",
    "data-name": "Heat Map BG",
    width: 49.75,
    height: 49.75,
    fill: "#aaafb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Heatmap_Square-40",
    "data-name": "Heatmap Square",
    transform: "translate(-708 -18754)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Heat_Map_BG-40",
    "data-name": "Heat Map BG",
    width: 49.75,
    height: 49.75,
    fill: "#aaafb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Heatmap_Square-41",
    "data-name": "Heatmap Square",
    transform: "translate(-367.833 -18803)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Heat_Map_BG-41",
    "data-name": "Heat Map BG",
    width: 49.75,
    height: 49.75,
    fill: "#96c5b6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Heatmap_Square-42",
    "data-name": "Heatmap Square",
    transform: "translate(-415.833 -18803)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Heat_Map_BG-42",
    "data-name": "Heat Map BG",
    width: 49.75,
    height: 49.75,
    fill: "#96c5b6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Heatmap_Square-43",
    "data-name": "Heatmap Square",
    transform: "translate(-465.024 -18803)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Heat_Map_BG-43",
    "data-name": "Heat Map BG",
    width: 49.75,
    height: 49.75,
    fill: "#96c5b6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Heatmap_Square-44",
    "data-name": "Heatmap Square",
    transform: "translate(-513.619 -18803)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Heat_Map_BG-44",
    "data-name": "Heat Map BG",
    width: 49.75,
    height: 49.75,
    fill: "#aaafb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Heatmap_Square-45",
    "data-name": "Heatmap Square",
    transform: "translate(-561.06 -18803)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Heat_Map_BG-45",
    "data-name": "Heat Map BG",
    width: 49.75,
    height: 49.75,
    fill: "#96c5b6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Heatmap_Square-46",
    "data-name": "Heatmap Square",
    transform: "translate(-609.81 -18803)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Heat_Map_BG-46",
    "data-name": "Heat Map BG",
    width: 49.75,
    height: 49.75,
    fill: "#00ae9d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Heatmap_Square-47",
    "data-name": "Heatmap Square",
    transform: "translate(-659 -18803)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Heat_Map_BG-47",
    "data-name": "Heat Map BG",
    width: 49.75,
    height: 49.75,
    fill: "#00ae9d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Heatmap_Square-48",
    "data-name": "Heatmap Square",
    transform: "translate(-708 -18803)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Heat_Map_BG-48",
    "data-name": "Heat Map BG",
    width: 49.75,
    height: 49.75,
    fill: "#00ae9d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Heatmap_Square-49",
    "data-name": "Heatmap Square",
    transform: "translate(-368.708 -18852)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Heat_Map_BG-49",
    "data-name": "Heat Map BG",
    width: 49.75,
    height: 49.75,
    fill: "#002927"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Heatmap_Square-50",
    "data-name": "Heatmap Square",
    transform: "translate(-416.708 -18852)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Heat_Map_BG-50",
    "data-name": "Heat Map BG",
    width: 49.75,
    height: 49.75,
    fill: "#002927"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Heatmap_Square-51",
    "data-name": "Heatmap Square",
    transform: "translate(-465.024 -18852)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Heat_Map_BG-51",
    "data-name": "Heat Map BG",
    width: 49.75,
    height: 49.75,
    fill: "#024642"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Heatmap_Square-52",
    "data-name": "Heatmap Square",
    transform: "translate(-513.619 -18852)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Heat_Map_BG-52",
    "data-name": "Heat Map BG",
    width: 49.75,
    height: 49.75,
    fill: "#00ae9d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Heatmap_Square-53",
    "data-name": "Heatmap Square",
    transform: "translate(-562.214 -18852)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Heat_Map_BG-53",
    "data-name": "Heat Map BG",
    width: 49.75,
    height: 49.75,
    fill: "#00ae9d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Heatmap_Square-54",
    "data-name": "Heatmap Square",
    transform: "translate(-609.81 -18852)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Heat_Map_BG-54",
    "data-name": "Heat Map BG",
    width: 49.75,
    height: 49.75,
    fill: "#008e7a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Heatmap_Square-55",
    "data-name": "Heatmap Square",
    transform: "translate(-659 -18852)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Heat_Map_BG-55",
    "data-name": "Heat Map BG",
    width: 49.75,
    height: 49.75,
    fill: "#96c5b6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Heatmap_Square-56",
    "data-name": "Heatmap Square",
    transform: "translate(-708 -18852)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Heat_Map_BG-56",
    "data-name": "Heat Map BG",
    width: 49.75,
    height: 49.75,
    fill: "#96c5b6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Heatmap_Square-57",
    "data-name": "Heatmap Square",
    transform: "translate(-367.833 -18901)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Heat_Map_BG-57",
    "data-name": "Heat Map BG",
    width: 49.75,
    height: 49.75,
    fill: "#d6d6d6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Heatmap_Square-58",
    "data-name": "Heatmap Square",
    transform: "translate(-415.833 -18901)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Heat_Map_BG-58",
    "data-name": "Heat Map BG",
    width: 49.75,
    height: 49.75,
    fill: "#aaafb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Heatmap_Square-59",
    "data-name": "Heatmap Square",
    transform: "translate(-465.024 -18901)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Heat_Map_BG-59",
    "data-name": "Heat Map BG",
    width: 49.75,
    height: 49.75,
    fill: "#96c5b6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Heatmap_Square-60",
    "data-name": "Heatmap Square",
    transform: "translate(-513.619 -18901)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Heat_Map_BG-60",
    "data-name": "Heat Map BG",
    width: 49.75,
    height: 49.75,
    fill: "#008e7a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Heatmap_Square-61",
    "data-name": "Heatmap Square",
    transform: "translate(-562.214 -18901)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Heat_Map_BG-61",
    "data-name": "Heat Map BG",
    width: 49.75,
    height: 49.75,
    fill: "#00ae9d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Heatmap_Square-62",
    "data-name": "Heatmap Square",
    transform: "translate(-609.81 -18901)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Heat_Map_BG-62",
    "data-name": "Heat Map BG",
    width: 49.75,
    height: 49.75,
    fill: "#008e7a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Heatmap_Square-63",
    "data-name": "Heatmap Square",
    transform: "translate(-659 -18901)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Heat_Map_BG-63",
    "data-name": "Heat Map BG",
    width: 49.75,
    height: 49.75,
    fill: "#024642"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Heatmap_Square-64",
    "data-name": "Heatmap Square",
    transform: "translate(-708 -18901)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Heat_Map_BG-64",
    "data-name": "Heat Map BG",
    width: 49.75,
    height: 49.75,
    fill: "#00ae9d"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeatmapsPrediction6);
export default __webpack_public_path__ + "static/media/heatmaps-prediction-6.db5ea04c65bc37b5216845ccb4ba0068.svg";
export { ForwardRef as ReactComponent };